import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, FormControl, Button, Alert } from 'react-bootstrap';
import UiUtils from '../../../../utils/UiUtils';
import Session from '../../../../utils/Session';
import logo from '../../../../images/logo-app.svg';
import './FormLogin.css';
import CompleteUserData from '../complete-user-data/CompleteUserData';

class FormLogin extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			username: "",
			usernameMinSize: 3,
			password: "",
			passwordMinSize: 8,
			isSubmitDisabled: true,
			mostrarCompleteUserData: false,
		}
	}

	handleChangeUsername = (event) => {
		this.setState({
			username: event.target.value,
			isSubmitDisabled: (
				event.target.value.length < this.state.usernameMinSize
				|| this.state.password.length < this.state.passwordMinSize
			),
		});
	}

	handleChangePassword = (event) => {
		this.setState({
			password: event.target.value,
			isSubmitDisabled: (
				event.target.value.length < this.state.passwordMinSize
				|| this.state.username.length < this.state.usernameMinSize
			),
		});
	}

	handleEnterPress = (ev) => {
		if (ev.key === 'Enter' && !this.checkSubmitDisabled()) {
			this.entrarClickHandler();
		}
	}

	checkSubmitDisabled = () => {
		return (
			this.state.username.length < this.state.usernameMinSize
			|| this.state.password.length < this.state.passwordMinSize
		);
	}


	entrarClickHandler = () => {
		if (this.checkSubmitDisabled()) {
			UiUtils.showAlert("Atención", "Verfique usuario y contraseña");
			return;
		}

		this.props.onLogin(this.state.username, this.state.password);
	}

	render() {
		return (
			<div className="container-fluid">
				<Row>
					<div className="Absolute-Center is-Responsive">
						{Session.isMainSite() &&
							<img
								src={logo}
								className="img-responsive center-block img-logo-large"
								alt="Agil Data" />
						}
						<Col>
							<FormGroup>
								<FormControl
									type="text"
									placeholder="Usuario"
									value={this.state.username}
									onChange={this.handleChangeUsername}
									onKeyPress={this.handleEnterPress}
									autoFocus="true" />
							</FormGroup>
							<FormGroup>
								<FormControl
									type="Password"
									placeholder="Contraseña"
									value={this.state.password}
									onChange={this.handleChangePassword}
									onKeyPress={this.handleEnterPress} />
							</FormGroup>
							<FormGroup>
								<Button
									bsStyle="primary"
									className="btn-block"
									disabled={this.state.isSubmitDisabled}
									onClick={this.entrarClickHandler}>
									Entrar
								</Button>
							</FormGroup>
							<FormGroup>
								<Button
									onClick={this.props.onMostrarRecuperarClave}
									className="btn-block  Btn-wrap">
									Olvidé mi contraseña
								</Button>
							</FormGroup>
							{process.env.REACT_APP_FLAVOR === "reseller" && (
								<FormGroup>
									<Button
										onClick={this.props.onMostrarSolicitarUsuario}
										className="btn-block  Btn-wrap">
										Solicitar usuario y contraseña
									</Button>
								</FormGroup>
							)}
							<Alert bsStyle='warning'>
								<h4 className='text-center'><strong>¡Atención!</strong></h4>
								<p>
									Recordá que nunca te vamos solicitar: <b>datos personales</b> o tu <b>Usuario y Contraseña</b> por <u>correo electrónico</u>, <u>llamados telefónicos</u>, <u>WSP</u>, <u>SMS</u> o <u>redes sociales</u>.
								</p>
								<p>
									Ante cualquier consulta o duda comunícate con tu asesor comercial.
								</p>
							</Alert>
						</Col>
					</div>
				</Row>

			</div>
		);
	}
}

FormLogin.propTypes = {
	onLogin: PropTypes.func,
	onMostrarRecuperarClave: PropTypes.func,
	onMostrarUserDemo: PropTypes.func
}

export default FormLogin;



// WEBPACK FOOTER //
// ./src/scenes/home/components/form-login/FormLogin.js